/**
 * First, we will load all of this project's Javascript utilities and other
 * dependencies. Then, we will be ready to develop a robust and powerful
 * application frontend using useful Laravel and JavaScript libraries.
 */

// require('./bootstrap');
import './bootstrap';

import html2canvas from 'html2canvas';
window.html2canvas = html2canvas;

window.initDeleteDialog = function () {
    $('form.myAction').on('submit', function (e) {
        e.preventDefault();
        var that = this;
        swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this record!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it'
        }).then((result) => {
            if (result.isConfirmed) {
                that.submit();
            }
        });
    });
};

import Login from './Login';
window.Login = Login;

import Site from './Site';
window.Site = Site;

import Settings from './Settings';
window.Settings = Settings;

import Generic from './Generic';
window.Generic = Generic;

import Administrator from './Administrator';
window.Administrator = Administrator;

import Academic from './Academic';
window.Academic = Academic;

import Statistics from './Statistics';
window.Statistics = Statistics;

import Reports from './reports';
window.Reports = Reports;

import HRM from './hrm';
window.HRM = HRM;